module.exports = __webpack_public_path__ + "static/VD-48f569b0a137acd2686d0dde9a23bee9.jpg";